import { pushToDatalayer } from '../../../utils/pushToDatalayer/pushToDatalayer'

type LoginParams = {
	logins: number
	location?: string
}

export const sendLoginEvent = (params: LoginParams): void => {
	const eventName = 'login'

	const payload = {
		event: 'GA4-login',
		event_name: eventName,
		search: {
			method: 'native',
			genesis: true,
			...params,
		},
	}

	pushToDatalayer(payload)
}
